import { writable } from 'svelte/store';
import '../ui-elements/element';
export const storageKey = 'uiElements';
function createElementSelectionStore() {
    let selectedElementIds = {};
    const { subscribe, set, update } = writable([]);
    subscribe((uiElements) => {
        selectedElementIds = {};
        uiElements.forEach((uiElement) => selectedElementIds[uiElement.id] = true);
    });
    return {
        subscribe,
        set: (uiElements) => set(uiElements),
        add: (uiElement) => update((elements) => [...elements, uiElement]),
        remove: (uiElementToRemove) => update((elements) => elements.filter((element) => element.id !== uiElementToRemove.id)),
        isSelected: (uiElement) => selectedElementIds[uiElement.id],
    };
}
export const elementSelectionStore = createElementSelectionStore();
